module.exports = __webpack_public_path__ + "static/media/scratch.237c1831.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scratch.svg
// module id = 225
// module chunks = 27